import { loadingSlice } from "./loadingSlice";

const { actions } = loadingSlice;

export const setActionLoading = (status) => (dispatch) => {
  return dispatch(actions.setLoadingAction({ status : status }));
};

export const getActionLoading = () => (dispatch) => {
  return dispatch(actions.getLoadingAction({ status: false }));
};
